window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

(function() {
  'use strict';

  var CART_AJAX_SECTION = 'cart-ajax';
  var CART_INTENTS = {
    ADD_OPEN_DRAWER: 'ADD_OPEN_DRAWER',
    ADD_SILENT: 'ADD_SILENT',
    LINE_UPDATE: 'LINE_UPDATE',
    ITEM_REMOVE: 'ITEM_REMOVE',
    CLEAR_CART: 'CLEAR_CART',
    LEGACY_COMPAT_ADD: 'LEGACY_COMPAT_ADD',
    COUNT_ONLY: 'COUNT_ONLY',
    COUNT_ONLY_OPTIMISTIC: 'COUNT_ONLY_OPTIMISTIC'
  };

  function getCartAjaxSection() {
    return theme.cart && theme.cart.cartAjaxSection
      ? theme.cart.cartAjaxSection
      : CART_AJAX_SECTION;
  }

  var cartSections = {
    getCartSectionsUrl: function() {
      return theme.routes.cartPage || '/cart';
    },

    getCartSectionParams: function() {
      return {
        sections: getCartAjaxSection(),
        sections_url: cartSections.getCartSectionsUrl()
      };
    },

    addCartSectionsToObject: function(data) {
      return Object.assign({}, data || {}, cartSections.getCartSectionParams());
    },

    addCartSectionsToUrlEncoded: function(data) {
      var params = cartSections.getCartSectionParams();
      var prefix = data ? data + '&' : '';
      return prefix + 'sections=' + encodeURIComponent(params.sections) +
        '&sections_url=' + encodeURIComponent(params.sections_url);
    },

    addCartSectionsWhenRequested: function(data, options) {
      options = options || {};
      var payload = Object.assign({}, data || {});
      return options.renderSections ? cartSections.addCartSectionsToObject(payload) : payload;
    }
  };

  function normalizeCartTelemetryUrl(url) {
    var text;
    var match;
    try {
      text = String(url || '');
      if (!text) {
        return '';
      }
      text = text.split('#')[0].split('?')[0];
      if (/^[a-z][a-z0-9+.-]*:\/\//i.test(text)) {
        match = text.match(/^[a-z][a-z0-9+.-]*:\/\/[^/]+(\/.*)?$/i);
        text = match && match[1] ? match[1] : '/';
      }
      return text.slice(0, 120);
    } catch (error) {
      return '';
    }
  }

  function cartTelemetryPerformanceNow() {
    try {
      return window.performance && typeof window.performance.now === 'function'
        ? window.performance.now()
        : null;
    } catch (error) {
      return null;
    }
  }

  function roundedNonNegative(value) {
    if (typeof value !== 'number' || !isFinite(value)) {
      return null;
    }
    return Math.round(Math.max(0, value));
  }

  function cartTelemetryHeader(response, name) {
    try {
      if (response && response.headers && typeof response.headers.get === 'function') {
        return String(response.headers.get(name) || '').slice(0, 160);
      }
    } catch (error) {}
    return '';
  }

  // HC - cart telemetry v2 - 2026-07-07
  // A cart write's telemetry `ms` is Date.now() measured across the fetch
  // .then(), so a backgrounded tab (or a main thread jammed by third-party
  // apps) inflates it to tens of seconds even though the /cart write itself
  // finished in ~1-2s (see rtDuration/serverTiming). Record whether the tab was
  // hidden during the write window so slow-`ms` events can be separated from
  // genuinely slow writes, plus a per-write actionId for correlation.
  var cartLastHiddenAt = 0;
  try {
    if (window.document && typeof window.document.addEventListener === 'function') {
      window.document.addEventListener('visibilitychange', function () {
        try {
          if (window.document.visibilityState === 'hidden') {
            cartLastHiddenAt = Date.now();
          }
        } catch (error) {}
      });
    }
  } catch (error) {}

  function cartDocHidden() {
    try {
      return !!(window.document && window.document.hidden);
    } catch (error) {
      return false;
    }
  }

  var cartActionCounter = 0;
  function cartTelemetryActionId() {
    cartActionCounter += 1;
    var rand = '';
    try {
      rand = Math.random().toString(36).slice(2, 8);
    } catch (error) {}
    return String(cartActionCounter) + '-' + rand;
  }

  // v2: capture the request-start write context ONCE, at the moment the POST is
  // dispatched. wasHiddenAtStart is essential: a write can begin while the tab is
  // ALREADY hidden and resolve after it becomes visible again — then neither
  // cartDocHidden() (visible at emit) nor cartLastHiddenAt >= netStartedAt (the tab
  // went hidden BEFORE the write started) flags it, so wasHidden would wrongly read
  // false for exactly the background-suspension case this signal exists to catch.
  function cartWriteContext() {
    return {
      netStartedAt: Date.now(),
      resourceStartedAt: cartTelemetryPerformanceNow(),
      actionId: cartTelemetryActionId(),
      wasHiddenAtStart: cartDocHidden()
    };
  }

  function cartUpdateResourceTiming(url, startedAt) {
    var normalizedUrl = normalizeCartTelemetryUrl(url);
    var entries;
    var entry;
    var index;
    var requestStart;
    var responseStart;
    var timing = {};
    try {
      if (!normalizedUrl || !window.performance || typeof window.performance.getEntriesByType !== 'function') {
        return timing;
      }
      entries = window.performance.getEntriesByType('resource') || [];
      for (index = entries.length - 1; index >= 0; index -= 1) {
        entry = entries[index];
        if (normalizeCartTelemetryUrl(entry && entry.name) !== normalizedUrl) {
          continue;
        }
        if (typeof startedAt === 'number' && typeof entry.startTime === 'number' && entry.startTime < startedAt - 50) {
          continue;
        }
        timing.rtDuration = roundedNonNegative(entry.duration);
        requestStart = typeof entry.requestStart === 'number' && entry.requestStart > 0
          ? entry.requestStart
          : entry.fetchStart;
        responseStart = typeof entry.responseStart === 'number' ? entry.responseStart : null;
        if (typeof responseStart === 'number' && typeof requestStart === 'number') {
          timing.rtTtfb = roundedNonNegative(responseStart - requestStart);
        }
        timing.rtTransferSize = roundedNonNegative(entry.transferSize);
        return timing;
      }
    } catch (error) {}
    return timing;
  }

  function cartNetTelemetryData(url, response, ctx) {
    var timing = cartUpdateResourceTiming(url, ctx.resourceStartedAt);
    var serverTiming = cartTelemetryHeader(response, 'server-timing');
    var data = {
      ms: Date.now() - ctx.netStartedAt,
      url: normalizeCartTelemetryUrl(url),
      // v2: true if the tab was hidden at ANY point in the write window — at start
      // (ctx.wasHiddenAtStart), at emit (cartDocHidden), or it went hidden in
      // between (cartLastHiddenAt >= start). A slow `ms` with wasHidden=true is page
      // suspension, not a slow server (compare rtDuration/serverTiming).
      wasHidden: !!ctx.wasHiddenAtStart || cartDocHidden() || (cartLastHiddenAt > 0 && cartLastHiddenAt >= ctx.netStartedAt)
    };
    if (ctx.actionId) {
      data.actionId = String(ctx.actionId).slice(0, 24);
    }
    if (response && typeof response.status === 'number') {
      data.status = response.status;
    }
    if (typeof timing.rtDuration === 'number') {
      data.rtDuration = timing.rtDuration;
    }
    if (typeof timing.rtTtfb === 'number') {
      data.rtTtfb = timing.rtTtfb;
    }
    if (typeof timing.rtTransferSize === 'number') {
      data.rtTransferSize = timing.rtTransferSize;
    }
    if (serverTiming) {
      data.serverTiming = serverTiming;
    }
    return data;
  }

  var CHALLENGE_MESSAGE = 'Your session needs a quick security check. Please refresh the page and try again.';

  // Detects Shopify/Cloudflare edge challenges (HTML / 403 / 503 where cart JSON
  // was expected) so cart code can recover with a clear message instead of
  // degrading to a generic error and firing more requests at a challenged session.
  var cartChallenge = {
    active: false,
    detectedAt: 0,
    episodeStartedAt: 0,
    timeoutMs: 30000,
    count: 0,
    timer: null,

    getHeader: function(response, name) {
      try {
        if (response && response.headers && typeof response.headers.get === 'function') {
          return response.headers.get(name) || '';
        }
      } catch (error) {}
      return '';
    },

    getContentType: function(response) {
      return cartChallenge.getHeader(response, 'content-type');
    },

    // The reliable fetch/XHR challenge signal per Cloudflare is the
    // `cf-mitigated: challenge` RESPONSE HEADER — readable same-origin even when
    // the challenge body is opaque/unreadable, so a header-only challenge is still
    // caught. (cf-mitigated is a header, never body text.)
    headerLooksLikeChallenge: function(response) {
      var mitigated = cartChallenge.getHeader(response, 'cf-mitigated');
      return typeof mitigated === 'string' &&
        mitigated.toLowerCase().indexOf('challenge') !== -1;
    },

    bodyLooksLikeChallenge: function(text) {
      if (!text || typeof text !== 'string') {
        return false;
      }
      // Parse-first: a genuine cart error returns JSON (e.g. a 422 inventory error
      // whose message may legitimately contain a broad phrase like "attention
      // required"); a real edge challenge is an HTML interstitial and is NEVER
      // valid JSON. Anything that parses as JSON is a cart error, not a challenge.
      var leading = text.replace(/^[\s﻿]+/, '');
      if (leading.charAt(0) === '{' || leading.charAt(0) === '[') {
        try {
          JSON.parse(text);
          return false;
        } catch (parseError) {
          // Not valid JSON — fall through to the HTML-interstitial check.
        }
      }
      // Require an HTML document shape AND a challenge marker. The HTML-shape gate
      // keeps a non-HTML body (plain text, or a broad phrase outside an
      // interstitial) off the challenge path; the marker keeps a genuine HTML
      // 5xx/maintenance page (no marker) off it. Real CF interstitials always
      // carry both. A bare <html> / <!doctype> alone is NOT a challenge. Window
      // widened to 1500 chars so a marker in the challenge-platform script (after
      // the <head>) is still seen.
      var head = text.slice(0, 1500).toLowerCase();
      if (head.indexOf('<!doctype') === -1 && head.indexOf('<html') === -1) {
        return false;
      }
      return head.indexOf('just a moment') !== -1 ||
        head.indexOf('needs to be verified') !== -1 ||
        head.indexOf('verifying you are human') !== -1 ||
        head.indexOf('checking your browser') !== -1 ||
        head.indexOf('enable javascript and cookies') !== -1 ||
        head.indexOf('attention required') !== -1 ||
        head.indexOf('cf-chl') !== -1 ||
        head.indexOf('challenge-platform') !== -1 ||
        (head.indexOf('cloudflare') !== -1 && head.indexOf('challenge') !== -1);
    },

    // A Cloudflare/Shopify edge challenge is detected from the RESPONSE HEADER
    // (`cf-mitigated: challenge` — Cloudflare's reliable fetch/XHR signal, which
    // works even when the body is opaque/unreadable) OR, as a fallback, the BODY
    // shape (an HTML interstitial carrying a challenge marker; see
    // bodyLooksLikeChallenge). Deliberately NOT HTTP status or content-type: a
    // genuine 403/5xx/maintenance response, even an HTML one, must stay on the
    // normal transient/retry path rather than be misclassified and freeze the
    // cart. (status/content-type are still recorded on the error object for
    // diagnostics — see challengeError — just not used to classify.)
    isChallengeResponse: function(response, bodyText) {
      return cartChallenge.headerLooksLikeChallenge(response) ||
        cartChallenge.bodyLooksLikeChallenge(bodyText);
    },

    clip: function(text, max) {
      if (typeof text !== 'string') {
        return text;
      }
      max = max || 1000;
      return text.length > max ? (text.slice(0, max) + '…[clipped]') : text;
    },

    // Monotonic generation captured when a cart request starts. A read that
    // began BEFORE a challenge armed must not clear the flag when it later
    // resolves with JSON (see clearOnSuccess); count increments on every
    // markActive, so a mismatch means a challenge armed while the read was in
    // flight. count never decrements, so it is a safe ownership stamp.
    generation: function() {
      return cartChallenge.count;
    },

    clearTimer: function() {
      if (cartChallenge.timer !== null && typeof clearTimeout === 'function') {
        clearTimeout(cartChallenge.timer);
      }
      cartChallenge.timer = null;
    },

    // Clear the active challenge (idempotent) and notify consumers exactly once
    // per active→inactive transition. Cart code that PARKS work while challenged
    // and early-outs without self-rescheduling (e.g. collection-atc's quick-add
    // queue) subscribes to 'cart:challenge:cleared' to drain it; without this
    // signal that parked work would strand until the next user gesture.
    deactivate: function() {
      if (!cartChallenge.active) {
        return;
      }
      var activeForMs = Date.now() - (cartChallenge.episodeStartedAt || cartChallenge.detectedAt);
      cartChallenge.active = false;
      cartChallenge.episodeStartedAt = 0;
      cartChallenge.clearTimer();
      // HC - cart telemetry - 2026-07-04
      var T = window.IBCartTelemetry; T && T.track('challenge:cleared', { activeForMs: activeForMs });
      if (typeof document !== 'undefined' && document.dispatchEvent &&
          typeof CustomEvent === 'function') {
        document.dispatchEvent(new CustomEvent('cart:challenge:cleared'));
      }
    },

    markActive: function() {
      var wasActive = cartChallenge.active === true;
      var detectedAt = Date.now();
      cartChallenge.active = true;
      cartChallenge.detectedAt = detectedAt;
      if (!wasActive) {
        cartChallenge.episodeStartedAt = detectedAt;
      }
      cartChallenge.count += 1; // local-only counter; never a network beacon
      // HC - cart telemetry - 2026-07-04
      var T = window.IBCartTelemetry; T && T.track(wasActive ? 'challenge:rearmed' : 'challenge:armed', { count: cartChallenge.count });
      if (typeof document !== 'undefined' && document.dispatchEvent &&
          typeof CustomEvent === 'function') {
        document.dispatchEvent(new CustomEvent('cart:challenge:active'));
      }

      // Arm a real timer so a quiet/background tab self-recovers without waiting
      // for a user gesture to call isActive(). Re-detection re-arms (clear the
      // old one first). Guard for vm/test environments that lack timers.
      cartChallenge.clearTimer();
      if (typeof setTimeout === 'function') {
        cartChallenge.timer = setTimeout(function() {
          cartChallenge.deactivate();
        }, cartChallenge.timeoutMs);
      }
    },

    isActive: function() {
      if (!cartChallenge.active) {
        return false;
      }
      // Elapsed-time fallback kept alongside the real setTimeout: background
      // tabs throttle (or never fire) timers, so this lazy check still clears
      // the flag the next time anything reads it past the timeout window.
      if ((Date.now() - cartChallenge.detectedAt) > cartChallenge.timeoutMs) {
        cartChallenge.deactivate();
      }
      return cartChallenge.active;
    },

    // Clears as soon as the cart returns readable JSON again — but only if the
    // request that produced it OWNS the current challenge generation. A passive
    // read that started before a challenge armed (startGeneration < current)
    // must not clear it; a genuine post-challenge read (generations match) does.
    // Only a validated cart counts as "readable JSON", not arbitrary JSON.
    clearOnSuccess: function(startGeneration, cart) {
      if (startGeneration !== undefined && startGeneration !== cartChallenge.count) {
        return;
      }
      if (cart !== undefined && !cartResult.isCartState(cart)) {
        return;
      }
      cartChallenge.deactivate();
    },

    challengeError: function(response, bodyText) {
      cartChallenge.markActive();
      var status = response ? response.status : 0;
      var err = new Error('Cart request blocked by a security check (' + status + ')');
      err.userMessage = CHALLENGE_MESSAGE;
      err.isSecurityChallenge = true;
      err.status = status;
      err.contentType = cartChallenge.getContentType(response);
      err.responseText = cartChallenge.clip(bodyText);
      return err;
    },

    suppressedError: function() {
      var err = new Error('Cart request suppressed during an active security check.');
      err.userMessage = CHALLENGE_MESSAGE;
      err.isSecurityChallenge = true;
      err.suppressedByChallenge = true;
      return err;
    }
  };

  var cartResult = {
    isCartState: function(cart) {
      return Boolean(cart && Array.isArray(cart.items) &&
        typeof cart.item_count === 'number' &&
        typeof cart.total_price === 'number');
    },

    sanitizeCartState: function(cart) {
      if (!cartResult.isCartState(cart)) {
        return null;
      }

      if (!cart.sections) {
        return cart;
      }

      var cartState = Object.assign({}, cart);
      delete cartState.sections;
      return cartState;
    },

    getCartState: function(payload) {
      if (payload && cartResult.isCartState(payload.cartState)) {
        return cartResult.sanitizeCartState(payload.cartState);
      }

      if (payload && cartResult.isCartState(payload.cart)) {
        return cartResult.sanitizeCartState(payload.cart);
      }

      if (payload && cartResult.isCartState(payload.raw)) {
        return cartResult.sanitizeCartState(payload.raw);
      }

      if (cartResult.isCartState(payload)) {
        return cartResult.sanitizeCartState(payload);
      }

      return null;
    },

    getCartSections: function(payload) {
      if (!payload) {
        return null;
      }

      if (payload.sections) {
        return payload.sections;
      }

      return payload.raw && payload.raw.sections ? payload.raw.sections : null;
    },

    getCartSectionHTML: function(cartOrSections) {
      var sections = cartResult.getCartSections(cartOrSections) || cartOrSections;
      if (!sections) {
        return null;
      }
      return sections[getCartAjaxSection()] || null;
    },

    // The cart-ajax section embeds the post-mutation cart as JSON so callers
    // can verify state straight from the bundled section response instead of
    // paying a serial /cart.js round trip.
    getEmbeddedCartState: function(cartOrSections) {
      var html = cartResult.getCartSectionHTML(cartOrSections);
      if (!html) {
        return null;
      }

      var markerIndex = html.indexOf('data-cart-ajax-state');
      if (markerIndex === -1) {
        return null;
      }

      var start = html.indexOf('>', markerIndex);
      var end = html.indexOf('</script>', start);
      if (start === -1 || end === -1) {
        return null;
      }

      try {
        return cartResult.getCartState(JSON.parse(html.slice(start + 1, end)));
      } catch (error) {
        return null;
      }
    },

    getRenderPayload: function(payload) {
      var sections = cartResult.getCartSections(payload);
      if (!sections) {
        return null;
      }

      return {
        cartState: cartResult.getCartState(payload),
        sections: sections
      };
    },

    getAddedItems: function(payload) {
      if (!payload) {
        return [];
      }

      if (Array.isArray(payload.items)) {
        return payload.items;
      }

      if (payload.id || payload.key || payload.variant_id) {
        return [payload];
      }

      return [];
    },

    buildMutationResult: function(payload, options) {
      options = options || {};
      var sections = options.sections || cartResult.getCartSections(payload);
      var cartState = options.cartState
        ? cartResult.getCartState(options.cartState)
        : cartResult.getCartState(payload);
      var addedItems = Array.isArray(options.addedItems)
        ? options.addedItems
        : (payload && Array.isArray(payload.addedItems) ? payload.addedItems : []);

      return {
        cartState: cartState,
        cart: cartState,
        sections: sections,
        addedItems: addedItems,
        raw: payload && payload.raw ? payload.raw : (payload || null)
      };
    },

    ensureLineMutationResult: function(payload) {
      var result = cartResult.buildMutationResult(payload);
      if (result.cartState) {
        return Promise.resolve(result);
      }

      var embeddedCartState = cartResult.getEmbeddedCartState(result.sections);
      if (embeddedCartState) {
        return Promise.resolve(cartResult.buildMutationResult(payload, {
          cartState: embeddedCartState,
          sections: result.sections,
          addedItems: result.addedItems
        }));
      }

      return cartTransport.getCart().then(function(cart) {
        var cartState = cartResult.getCartState(cart);
        if (!cartState) {
          var err = new Error('Unable to verify cart state after cart update.');
          if (cartChallenge.isActive()) {
            err.userMessage = CHALLENGE_MESSAGE;
            err.isSecurityChallenge = true;
          } else {
            err.userMessage = 'Unable to verify cart. Please refresh and try again.';
          }
          throw err;
        }

        return cartResult.buildMutationResult(payload, {
          cartState: cartState,
          sections: result.sections,
          addedItems: result.addedItems
        });
      });
    }
  };

  // All cart write mutations flow through one promise chain so requests
  // reach Shopify in dispatch order and responses can't apply out of order.
  var cartMutationQueueDepth = 0;
  var cartMutationQueue = {
    tail: Promise.resolve(),

    enqueue: function(operation) {
      var enqueuedAt = Date.now();
      cartMutationQueueDepth += 1;
      var run = this.tail.then(function() {
        // HC - cart telemetry - 2026-07-04
        // depth = ops enqueued-and-unsettled at drain time (includes later-enqueued ops), not queue position; waitMs is the primary signal.
        var T = window.IBCartTelemetry; T && T.track('queue', { waitMs: Date.now() - enqueuedAt, depth: cartMutationQueueDepth });
        // Re-check the challenge at drain time, not only at submit time. Writes
        // queued back-to-back all clear the entry-point guard before the first
        // one resolves; once that first POST classifies the challenge, every
        // operation still sitting in the queue must be suppressed here instead
        // of firing another POST at the challenged origin. The entry-point
        // check in postCartAdd/updateCart stays as a cheap early-out.
        if (cartChallenge.isActive()) {
          var T = window.IBCartTelemetry; T && T.track('write:suppressed');
          return Promise.reject(cartChallenge.suppressedError());
        }
        return operation();
      });

      // Keep the chain alive after failures, and drop any shared in-flight
      // cart read once a mutation settles; that snapshot is stale now.
      this.tail = run.then(function() {}, function() {}).then(function() {
        cartMutationQueueDepth = Math.max(0, cartMutationQueueDepth - 1);
        cartTransport.cartReadInFlight = null;
      });

      return run;
    }
  };

  // Read an error/challenge response body, failing closed when the body is
  // unreadable: resolve to '' so the non-ok response is still classified (by the
  // cf-mitigated header or body shape; see isChallengeResponse) and never silently
  // becomes a generic success. Only used on !response.ok paths.
  function readResponseText(response) {
    return response.text().catch(function() {
      return '';
    });
  }

  function parseCartJsonResponse(response, startGeneration) {
    return response.text().then(function(bodyText) {
      var parsed;
      try {
        parsed = JSON.parse(bodyText);
      } catch (parseError) {
        if (cartChallenge.isChallengeResponse(response, bodyText)) {
          throw cartChallenge.challengeError(response, bodyText);
        }
        throw parseError;
      }
      // Clear only if this read still owns the challenge generation and the
      // payload is a real cart (see clearOnSuccess).
      cartChallenge.clearOnSuccess(startGeneration, parsed);
      return parsed;
    });
  }

  var cartTransport = {
    cartReadInFlight: null,

    getCart: function() {
      // Concurrent readers share one in-flight request; mutations clear it
      // so post-write reads always hit the network fresh.
      if (cartTransport.cartReadInFlight) {
        return cartTransport.cartReadInFlight;
      }

      // Capture the challenge generation at request start so a JSON resolve
      // from a read that predates a later challenge can't clear the flag.
      var startGeneration = cartChallenge.generation();
      var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
      var request = fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      })
      .then(function(response) {
        if (!response.ok) {
          return readResponseText(response).then(function(errorText) {
            if (cartChallenge.isChallengeResponse(response, errorText)) {
              throw cartChallenge.challengeError(response, errorText);
            }
            throw new Error('getCart failed (' + response.status + '): ' + cartChallenge.clip(errorText));
          });
        }
        return parseCartJsonResponse(response, startGeneration);
      })
      .catch(function(error) {
        console.warn('getCart failed:', error);
        return null;
      })
      .finally(function() {
        if (cartTransport.cartReadInFlight === request) {
          cartTransport.cartReadInFlight = null;
        }
      });

      cartTransport.cartReadInFlight = request;
      return request;
    },

    getDefaultFetch: function() {
      if (theme.utils && typeof theme.utils.fetchWithRetry === 'function') {
        return function(url, options) {
          return theme.utils.fetchWithRetry(url, options, {
            retries: 2,
            baseDelay: 500,
            maxDelay: 2000,
            retryOn5xx: false,
            // /cart/add.js is not idempotent: a request Shopify applied whose
            // response never arrived would double-add if retried. retryOn defaults
            // to [429, 409]; force [] so a challenged or throttled add never retries.
            retryOn: [],
            retryOnNetworkError: false
          });
        };
      }

      return fetch;
    },

    parseCartResponse: function(response, fallbackMessage, startGeneration) {
      if (!response.ok) {
        return readResponseText(response).then(function(errorText) {
          if (cartChallenge.isChallengeResponse(response, errorText)) {
            throw cartChallenge.challengeError(response, errorText);
          }
          var parsedMessage = theme.utils && theme.utils.parseAjaxError
            ? theme.utils.parseAjaxError(errorText)
            : errorText;
          var message = theme.utils && theme.utils.normalizeCartError
            ? theme.utils.normalizeCartError(parsedMessage)
            : parsedMessage;
          var err = new Error(message || fallbackMessage || 'Cart update failed');
          err.userMessage = err.message;
          err.status = response.status;
          err.contentType = cartChallenge.getContentType(response);
          err.responseText = cartChallenge.clip(errorText);
          throw err;
        });
      }

      return parseCartJsonResponse(response, startGeneration);
    },

    postCartAdd: function(requestOptions) {
      if (cartChallenge.isActive()) {
        var T = window.IBCartTelemetry; T && T.track('write:suppressed');
        return Promise.reject(cartChallenge.suppressedError());
      }
      return cartMutationQueue.enqueue(function() {
        return cartTransport.performCartAdd(requestOptions);
      });
    },

    performCartAdd: function(requestOptions) {
      var fetcher = cartTransport.getDefaultFetch();
      // Capture the challenge generation at the moment the add POST starts so a
      // success response only clears the flag if no challenge armed in between.
      var startGeneration = cartChallenge.generation();
      var ctx = cartWriteContext();

      return fetcher(theme.routes.cartAdd, requestOptions)
        .then(function(response) {
          // HC - cart telemetry - 2026-07-04
          var T = window.IBCartTelemetry; T && T.track('add:net', cartNetTelemetryData(theme.routes.cartAdd, response, ctx));
          return cartTransport.parseCartResponse(response, 'Unable to add item to cart. Please try again.', startGeneration);
        })
        .then(function(addResponse) {
          var sections = cartResult.getCartSections(addResponse);
          var addedItems = cartResult.getAddedItems(addResponse);

          // The bundled cart-ajax section embeds the post-add cart state, so
          // the verification /cart.js fetch is only a fallback for responses
          // that came back without a readable embedded payload.
          var embeddedCartState = cartResult.getEmbeddedCartState(sections);
          if (embeddedCartState) {
            return cartResult.buildMutationResult(addResponse, {
              cartState: embeddedCartState,
              sections: sections,
              addedItems: addedItems
            });
          }

          // Fallback verification read. Mirror the line-update path
          // (ensureLineMutationResult): if /cart.js can't be read into a cart —
          // e.g. the verification GET was itself an edge challenge, which getCart
          // swallows into null after setting the challenge flag — reject with the
          // security-check message instead of resolving a "success" with a null
          // cart that would open an optimistic drawer over stale content.
          return cartTransport.getCart().then(function(cart) {
            var cartState = cartResult.getCartState(cart);
            if (!cartState) {
              var err = new Error('Unable to verify cart state after adding to cart.');
              if (cartChallenge.isActive()) {
                err.userMessage = CHALLENGE_MESSAGE;
                err.isSecurityChallenge = true;
              } else {
                err.userMessage = 'Unable to verify cart. Please refresh and try again.';
              }
              throw err;
            }

            return cartResult.buildMutationResult(addResponse, {
              cartState: cartState,
              sections: sections,
              addedItems: addedItems
            });
          });
        });
    },

    getCartProductMarkup: function() {
      // Capture the challenge generation at request start so a read predating a
      // later challenge can't clear the flag when its JSON resolves.
      var startGeneration = cartChallenge.generation();
      var url = cartSections.getCartSectionsUrl();
      url = url.indexOf('?') === -1 ? (url + '?') : (url + '&');
      url += 'sections=' + encodeURIComponent(getCartAjaxSection()) +
        '&sections_url=' + encodeURIComponent(cartSections.getCartSectionsUrl()) +
        '&t=' + Date.now();

      // HC - Guard cart markup fetch errors - 2026-01-27
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      })
      .then(function(response) {
        if (!response.ok) {
          return readResponseText(response).then(function(errorText) {
            if (cartChallenge.isChallengeResponse(response, errorText)) {
              throw cartChallenge.challengeError(response, errorText);
            }
            throw new Error('Cart markup fetch failed: ' + response.status);
          });
        }
        // parseCartJsonResponse performs the generation-aware clear; no second
        // clearOnSuccess needed here (and the old one ran before the !html guard).
        return parseCartJsonResponse(response, startGeneration);
      })
      .then(function(sections) {
        var html = cartResult.getCartSectionHTML(sections);
        if (!html) {
          throw new Error('Cart Ajax section missing from response');
        }
        return html;
      });
    },

    updateCart: function(params) {
      if (cartChallenge.isActive()) {
        var T = window.IBCartTelemetry; T && T.track('write:suppressed');
        return Promise.reject(cartChallenge.suppressedError());
      }
      return cartMutationQueue.enqueue(function() {
        return cartTransport.performCartUpdate(params);
      });
    },

    performCartUpdate: function(params) {
      // Capture the challenge generation at the moment the update POST starts so
      // a success response only clears the flag if no challenge armed in between.
      var startGeneration = cartChallenge.generation();
      var ctx = cartWriteContext();
      return fetch(params.url, {
        method: 'POST',
        body: params.data,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(function(response) {
        // HC - cart telemetry - 2026-07-04
        var T = window.IBCartTelemetry; T && T.track('update:net', cartNetTelemetryData(params.url, response, ctx));
        if (!response.ok) {
          return readResponseText(response).then(function(errorText) {
            if (cartChallenge.isChallengeResponse(response, errorText)) {
              throw cartChallenge.challengeError(response, errorText);
            }

            var err = new Error('Cart update failed (' + response.status + '): ' + cartChallenge.clip(errorText));
            err.status = response.status;
            err.responseText = cartChallenge.clip(errorText);
            err.contentType = cartChallenge.getContentType(response);

            var parsedMessage = theme.utils && theme.utils.parseAjaxError
              ? theme.utils.parseAjaxError(errorText)
              : null;
            var normalizedMessage = theme.utils && theme.utils.normalizeCartError
              ? theme.utils.normalizeCartError(parsedMessage)
              : parsedMessage;
            err.userMessage = normalizedMessage || 'Unable to update cart. Please try again.';

            throw err;
          });
        }
        return parseCartJsonResponse(response, startGeneration);
      });
    }
  };

  var cartEvents = {
    updated: function(result, options) {
      options = options || {};
      result = result || {};

      var cartState = cartResult.getCartState(result);
      var sections = result.sections || cartResult.getCartSections(result);
      var detail = {
        source: options.source || 'cart',
        openCart: options.openCart === true,
        cartState: cartState,
        sections: sections,
        addedItems: result.addedItems || null
      };

      if (cartState) {
        detail.cart = cartState;
      }

      if (typeof options.item_count === 'number') {
        detail.item_count = options.item_count;
      }

      if (options.detail) {
        Object.assign(detail, options.detail);
      }

      // optimisticGeneration correlates an optimistic count event with the
      // authoritative event of the SAME add (both carry the generation stamped by
      // optimisticCartCount.bump), so consumers can tell when the verified cart
      // reflects the latest add rather than an older in-flight one.
      ['renderedLocation', 'lightweight', 'countOnly', 'optimistic', 'optimisticGeneration', 'optimisticRevert', 'cartQuantityKey'].forEach(function(key) {
        if (options[key] !== undefined) {
          detail[key] = options[key];
        }
      });

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: detail
      }));

      return detail;
    },

    ajaxProductAdded: function(result, options) {
      options = options || {};
      result = result || {};

      var cartState = cartResult.getCartState(result);
      var addedItems = result.addedItems || [];
      var product = options.product || addedItems[0] || result.raw || cartState || null;
      var detail = {
        source: options.source || 'cart',
        product: product,
        addedItems: addedItems,
        cartState: cartState,
        sections: result.sections || cartResult.getCartSections(result),
        addToCartBtn: options.addToCartBtn || null,
        skipCartBuild: true
      };

      if (cartState) {
        detail.cart = cartState;
        detail.item_count = cartState.item_count;
      }

      if (options.skipCartOpen !== undefined) {
        detail.skipCartOpen = options.skipCartOpen;
      }

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: detail
      }));

      if (options.scopedEventId) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added:' + options.scopedEventId, {
          detail: detail
        }));
      }

      return detail;
    },

    legacyCartEvents: function(result, options) {
      options = options || {};
      result = result || {};

      var cartState = cartResult.getCartState(result);
      var addedItems = result.addedItems || [];
      var product = options.product || addedItems[0] || result.raw || cartState || null;
      var detail = {
        product: product,
        cartState: cartState,
        cart: cartState
      };

      if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
        window.Shopify.onItemAdded(product || cartState);
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:item-added', {
        bubbles: true,
        detail: detail
      }));

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: detail
      }));

      document.dispatchEvent(new CustomEvent('theme:cart:change', {
        bubbles: true,
        detail: detail
      }));

      window.dispatchEvent(new CustomEvent('theme:cart:updated', {
        bubbles: true,
        detail: detail
      }));

      window.dispatchEvent(new Event('cart.requestComplete'));

      if (typeof window.ajaxCart !== 'undefined' && window.ajaxCart.load) {
        window.ajaxCart.load();
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        detail: detail
      }));
    },

    addOpenDrawer: function(result, options) {
      options = options || {};
      cartEvents.updated(result, Object.assign({}, options, {
        openCart: true
      }));
      cartEvents.ajaxProductAdded(result, options);
      return result;
    },

    addSilent: function(result, options) {
      options = options || {};
      cartEvents.updated(result, options);
      cartEvents.ajaxProductAdded(result, options);
      return result;
    },

    lineMutation: function(result, options) {
      options = options || {};
      var addedProducts = Array.isArray(options.addedProducts) ? options.addedProducts : [];

      cartEvents.updated(result, options);

      addedProducts.forEach(function(product) {
        cartEvents.ajaxProductAdded(result, Object.assign({}, options, {
          product: product,
          skipCartOpen: true
        }));
      });

      return result;
    },

    itemRemove: function(result, options) {
      options = options || {};
      cartEvents.updated(result, Object.assign({
        source: 'cart-remove'
      }, options));
      return result;
    },

    clearCart: function(result, options) {
      options = options || {};
      cartEvents.updated(result, Object.assign({
        source: 'cart-clear'
      }, options));
      return result;
    },

    legacyCompatAdd: function(result, options) {
      options = options || {};
      cartEvents.updated(result, Object.assign({}, options, {
        openCart: true
      }));
      cartEvents.ajaxProductAdded(result, options);
      cartEvents.legacyCartEvents(result, options);
      return result;
    },

    countOnly: function(result, options) {
      options = options || {};
      cartEvents.updated(result, Object.assign({}, options, {
        lightweight: true,
        countOnly: true
      }));
      return result;
    },

    countOnlyOptimistic: function(result, options) {
      options = options || {};
      cartEvents.updated(result, Object.assign({}, options, {
        lightweight: true,
        countOnly: true,
        optimistic: true
      }));
      return result;
    },

    // Optimistic drawer open — dispatches cart:open {optimistic:true}. No longer
    // wired into the default Add-to-Cart flow: the drawer now opens only AFTER the
    // add resolves, fully populated, while the Add button spins ("wait, then
    // open"). Retained as an opt-in on the public dispatch API
    // (dispatchOpenDrawerIntent) for callers that deliberately want an instant,
    // server-rendered pre-open.
    openDrawerIntent: function(options) {
      options = options || {};
      document.dispatchEvent(new CustomEvent('cart:open', {
        detail: {
          source: options.source || 'cart',
          optimistic: true
        }
      }));
    },

    // Add-to-Cart no longer opens the drawer optimistically (it opens only after
    // the add resolves, fully populated). This still matters when the drawer was
    // ALREADY open (e.g. an in-drawer quick-add from cart recommendations): if a
    // security challenge blocks the add, close it so the security message isn't
    // shown over stale content. A cart:close on an already-closed drawer is a safe
    // no-op (theme.js close() early-returns when !config.cartOpen). addError still
    // fires and the error still throws.
    closeDrawerIfChallenge: function(error) {
      if (error && error.isSecurityChallenge) {
        document.dispatchEvent(new CustomEvent('cart:close'));
      }
    },

    addError: function(error, options) {
      options = options || {};
      var raw = error && error.raw ? error.raw : null;
      var message = (error && error.userMessage) ||
        (raw && (raw.description || raw.message)) ||
        'Unable to add item to cart. Please try again.';
      var detail = {
        message: message,
        source: options.source || 'cart'
      };

      if (options.selfRendersAddError === true) {
        detail.selfRendered = true;
      }

      if (error && error.suppressedByChallenge === true) {
        detail.suppressedByChallenge = true;
      }

      document.dispatchEvent(new CustomEvent('cart:add:error', {
        detail: detail
      }));
    },

    addErrorIfRejected: function(result, options) {
      if (result && result.raw && (result.raw.status === 422 || result.raw.status === 'bad_request')) {
        cartEvents.addError(result, options);
      }
      return result;
    }
  };

  var legacyIntentDispatchers = {};
  legacyIntentDispatchers[CART_INTENTS.ADD_OPEN_DRAWER] = cartEvents.addOpenDrawer;
  legacyIntentDispatchers[CART_INTENTS.ADD_SILENT] = cartEvents.addSilent;
  legacyIntentDispatchers[CART_INTENTS.ITEM_REMOVE] = cartEvents.itemRemove;
  legacyIntentDispatchers[CART_INTENTS.CLEAR_CART] = cartEvents.clearCart;
  legacyIntentDispatchers[CART_INTENTS.LEGACY_COMPAT_ADD] = cartEvents.legacyCompatAdd;
  legacyIntentDispatchers[CART_INTENTS.COUNT_ONLY] = cartEvents.countOnly;
  legacyIntentDispatchers[CART_INTENTS.COUNT_ONLY_OPTIMISTIC] = cartEvents.countOnlyOptimistic;
  legacyIntentDispatchers[CART_INTENTS.LINE_UPDATE] = cartEvents.lineMutation;

  function dispatchByLegacyIntent(result, options) {
    options = options || {};
    var dispatch = legacyIntentDispatchers[options.intent] || cartEvents.lineMutation;
    return dispatch(result, options);
  }

  function dispatchIfAccepted(result, dispatch, options) {
    if (result && result.raw && (result.raw.status === 422 || result.raw.status === 'bad_request')) {
      return result;
    }

    dispatch(result, options || {});
    return result;
  }

  function getLineDispatchOptions(options) {
    var dispatchOptions = Object.assign({}, options || {});
    delete dispatchOptions.intent;
    return dispatchOptions;
  }

  function updateCartPayload(payload, options) {
    options = options || {};

    return cartTransport.updateCart({
      url: theme.routes.cartUpdate,
      data: JSON.stringify(cartSections.addCartSectionsWhenRequested(payload, options))
    })
    .then(function(cart) {
      return cartResult.buildMutationResult(cart);
    });
  }

  function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
      attribute += '';
      if (attribute === 'undefined') {
        attribute = '';
      }
    }
    return attribute.trim();
  }

  theme.cart = {
    cartAjaxSection: CART_AJAX_SECTION,
    intents: CART_INTENTS,
    challenge: cartChallenge,
    isChallengeActive: function() { return cartChallenge.isActive(); },

    getCart: cartTransport.getCart,
    getCartSectionsUrl: cartSections.getCartSectionsUrl,
    getCartSectionParams: cartSections.getCartSectionParams,
    addCartSectionsToObject: cartSections.addCartSectionsToObject,
    addCartSectionsToUrlEncoded: cartSections.addCartSectionsToUrlEncoded,
    addCartSectionsWhenRequested: cartSections.addCartSectionsWhenRequested,

    isCartState: cartResult.isCartState,
    sanitizeCartState: cartResult.sanitizeCartState,
    getCartState: cartResult.getCartState,
    getCartSections: cartResult.getCartSections,
    getCartSectionHTML: cartResult.getCartSectionHTML,
    getEmbeddedCartState: cartResult.getEmbeddedCartState,
    getRenderPayload: cartResult.getRenderPayload,
    getAddedItems: cartResult.getAddedItems,
    buildMutationResult: cartResult.buildMutationResult,
    ensureLineMutationResult: cartResult.ensureLineMutationResult,

    getDefaultFetch: cartTransport.getDefaultFetch,
    parseCartResponse: cartTransport.parseCartResponse,
    postCartAdd: cartTransport.postCartAdd,

    dispatchCartUpdated: cartEvents.updated,
    dispatchAjaxProductAdded: cartEvents.ajaxProductAdded,
    dispatchLegacyCartEvents: cartEvents.legacyCartEvents,
    dispatchAddOpenDrawer: cartEvents.addOpenDrawer,
    dispatchAddSilent: cartEvents.addSilent,
    dispatchLineMutation: cartEvents.lineMutation,
    dispatchItemRemove: cartEvents.itemRemove,
    dispatchClearCart: cartEvents.clearCart,
    dispatchLegacyCompatAdd: cartEvents.legacyCompatAdd,
    dispatchCountOnly: cartEvents.countOnly,
    dispatchCountOnlyOptimistic: cartEvents.countOnlyOptimistic,
    dispatchOpenDrawerIntent: cartEvents.openDrawerIntent,
    dispatchAddError: cartEvents.addError,

    dispatchCartMutation: function(result, options) {
      return dispatchByLegacyIntent(result, options);
    },

    dispatchLineUpdate: function(payload, options) {
      options = options || {};
      if (!payload) {
        return null;
      }

      var result = cartResult.buildMutationResult(payload, options);
      return cartEvents.lineMutation(result, getLineDispatchOptions(options));
    },

    dispatchCartCount: function(itemCount, options) {
      options = Object.assign({}, options || {}, {
        item_count: itemCount
      });

      if (options.intent === CART_INTENTS.COUNT_ONLY_OPTIMISTIC) {
        return cartEvents.countOnlyOptimistic(null, options);
      }

      return cartEvents.countOnly(null, options);
    },

    dispatchResultIfAccepted: function(result, intent, options) {
      return dispatchIfAccepted(result, function(finalResult, finalOptions) {
        return dispatchByLegacyIntent(finalResult, Object.assign({}, finalOptions || {}, {
          intent: intent
        }));
      }, options);
    },

    addSilently: function(items, options) {
      return this.addItems(items).then(function(result) {
        return dispatchIfAccepted(result, cartEvents.addSilent, options);
      });
    },

    addAndOpenDrawer: function(id, quantity, options) {
      return this.addItem(id, quantity).then(function(result) {
        cartEvents.addErrorIfRejected(result, options);
        return dispatchIfAccepted(result, cartEvents.addOpenDrawer, options);
      }, function(error) {
        // Close challenge-opened drawers before the error event; otherwise the
        // inline drawer branch renders the message, then cart:close hides it.
        cartEvents.closeDrawerIfChallenge(error);
        cartEvents.addError(error, options);
        throw error;
      });
    },

    addSerializedFormAndOpenDrawer: function(serializedForm, options) {
      return this.addSerializedForm(serializedForm).then(function(result) {
        cartEvents.addErrorIfRejected(result, options);
        return dispatchIfAccepted(result, cartEvents.addOpenDrawer, options);
      }, function(error) {
        // Close challenge-opened drawers before the error event; otherwise the
        // inline drawer branch renders the message, then cart:close hides it.
        cartEvents.closeDrawerIfChallenge(error);
        cartEvents.addError(error, options);
        throw error;
      });
    },

    addLegacyCompatItem: function(id, quantity, options) {
      return this.addItem(id, quantity).then(function(result) {
        return dispatchIfAccepted(result, cartEvents.legacyCompatAdd, options);
      });
    },

    getLineDispatchOptions: getLineDispatchOptions,

    changeLineAndBroadcast: function(key, qty, options) {
      return this.changeItem(key, qty).then(function(result) {
        return cartResult.ensureLineMutationResult(result);
      }).then(function(result) {
        cartEvents.lineMutation(result, getLineDispatchOptions(options));
        return result;
      });
    },

    updateCartAndBroadcast: function(updates, options) {
      return this.updateCart(updates).then(function(result) {
        return cartResult.ensureLineMutationResult(result);
      }).then(function(result) {
        cartEvents.lineMutation(result, getLineDispatchOptions(options));
        return result;
      });
    },

    broadcastLineUpdate: function(payload, options) {
      return this.dispatchLineUpdate(payload, options);
    },

    removeDrawerLine: function(lineKey, options) {
      return this.changeItem(lineKey, 0).then(function(result) {
        cartEvents.itemRemove(result, options);
        return result;
      });
    },

    clearDrawerCart: function(note, options) {
      return this.clearCartWithNote(note || '').then(function(result) {
        var cartState = cartResult.getCartState(result);
        if (!cartState) {
          throw new Error('Unable to verify cart.');
        }

        if (cartState.item_count !== 0) {
          throw new Error('Clear cart did not remove all items.');
        }

        cartEvents.clearCart(result, options);
        return result;
      });
    },

    addItems: function(items, options) {
      options = options || {};

      return cartTransport.postCartAdd(Object.assign({}, options, {
        method: 'POST',
        body: JSON.stringify(cartSections.addCartSectionsToObject({
          items: items
        })),
        credentials: options.credentials || 'same-origin',
        headers: Object.assign({
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }, options.headers || {})
      }));
    },

    addItem: function(id, quantity, options) {
      return this.addItems([{
        id: id,
        quantity: quantity == null ? 1 : quantity
      }], options);
    },

    addSerializedForm: function(serializedForm, options) {
      options = options || {};

      return cartTransport.postCartAdd(Object.assign({}, options, {
        method: 'POST',
        body: cartSections.addCartSectionsToUrlEncoded(serializedForm),
        credentials: options.credentials || 'same-origin',
        headers: Object.assign({
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }, options.headers || {})
      }));
    },

    getCartProductMarkup: cartTransport.getCartProductMarkup,

    changeItem: function(key, qty, options) {
      return cartTransport.updateCart({
        url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify(cartSections.addCartSectionsToObject({
          id: key,
          quantity: qty
        }))
      })
      .then(function(cart) {
        return cartResult.buildMutationResult(cart);
      });
    },

    updateCart: function(updates, options) {
      return updateCartPayload({
        updates: updates
      }, Object.assign({
        renderSections: true
      }, options || {}));
    },

    clearCart: function(options) {
      return cartTransport.updateCart({
        url: theme.routes.cartClear,
        data: JSON.stringify(cartSections.addCartSectionsToObject({}))
      })
      .then(function(cart) {
        return cartResult.buildMutationResult(cart);
      });
    },

    _updateCart: cartTransport.updateCart,
    updateCartPayload: updateCartPayload,

    clearCartWithNote: function(note, options) {
      options = Object.assign({
        renderSections: true
      }, options || {});

      var desiredNote = attributeToString(note || '');

      // cart/clear.js empties every line in one request and preserves the
      // saved note and attributes; only unsaved drawer edits need a follow-up.
      return this.clearCart().then(function(result) {
        var cartState = cartResult.getCartState(result);
        var savedNote = attributeToString(cartState && cartState.note != null ? cartState.note : '');

        if (savedNote === desiredNote) {
          return result;
        }

        return updateCartPayload({
          note: desiredNote
        }, options).catch(function(error) {
          // The cart is already cleared; a failed note save must not report
          // the clear itself as failed.
          console.warn('Cart cleared but note save failed:', error);
          return result;
        });
      });
    },

    updateAttribute: function(key, value, options) {
      return updateCartPayload({
        attributes: {
          [key]: attributeToString(value)
        }
      }, options);
    },

    updateNote: function(note, options) {
      return updateCartPayload({
        note: attributeToString(note)
      }, options);
    },

    updateNoteWithSections: function(note) {
      return this.updateNote(note, {
        renderSections: true
      });
    },

    attributeToString: attributeToString
  };
})();
